module.exports = __webpack_public_path__ + "cbf5d0325768aac552b0db2b2c6e21ec.svg";